export default __webpack_public_path__ + "static/media/geodatin_map.d52eeeac.svg";